import { useCallback } from "react";
import { useAuth } from "../componenti/AuthContext";

const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:8080").replace(/\/$/, "");

export const useAuthFetch = () => {
  const { user, login, logout } = useAuth();

  const authFetch = useCallback(async (url, options = {}) => {
    const headers = options.headers ? { ...options.headers } : {};

    if (user?.accessToken) {
      headers["Authorization"] = `Bearer ${user.accessToken}`;
    }

    let response = await fetch(url, { ...options, headers });

    // refresh SOLO su 401 (token scaduto / non valido)
    if (response.status === 401) {
      console.warn(`🚫 401 per URL: ${url} -> provo refresh`);

      if (!user?.refreshToken) {
        logout();
        throw new Error("Sessione scaduta, esegui di nuovo il login");
      }

      const refreshResponse = await fetch(`${API_URL}/api/auth/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken: user.refreshToken }),
      });

      if (!refreshResponse.ok) {
        logout();
        throw new Error("Sessione scaduta, esegui di nuovo il login");
      }

      const data = await refreshResponse.json();

      login({
        accessToken: data.accessToken,
        refreshToken: data.refreshToken,
        ruolo: data.ruolo ?? user?.ruolo,
        username: data.username ?? user?.username,
      });

      const retryHeaders = { ...headers, Authorization: `Bearer ${data.accessToken}` };
      response = await fetch(url, { ...options, headers: retryHeaders });
    }

    return response;
  }, [user, login, logout]);

  return authFetch;
};